<template>
    <div class="ma-4">
        <v-snackbar v-model="msg" top> {{ text }}
            <v-btn color="pink" text @click="msg = false"> Close</v-btn>
        </v-snackbar>
        <v-card>
            <v-layout row wrap class="pa-2 ma-2 hideOnPrint">
                <v-flex xs12>
                    <v-btn fab x-small @click="$router.go(-1)">
                        <v-icon>navigate_before</v-icon>

                    </v-btn>
                </v-flex>

                <v-flex xs12 md1 class="mb-2">
                    <v-btn
                        fab
                        small
                        @click="printTable()"
                        class="ml-8 white--text"
                        color="#2b6993"
                        elevation="4"
                        absolute
                        right
                    >
                        <v-icon>print</v-icon>
                    </v-btn>
                </v-flex>

                <v-flex xs12>
                    <h3 class="text-center mb-5">Nevada Incident Report</h3>
                    <v-divider class="ml-4 mr-4 mb-3"></v-divider>
                </v-flex>

                <v-flex xs12>
                    <v-card
                        class="ma-3 pa-3"
                        elevation="0"
                    >
                        <v-layout row wrap>
                            <v-flex xs12 md2 class="pa-1">
                                <DatePicker
                                    :default-date="startDate"
                                    v-model="startDate"
                                    label="Start Date"
                                />
                            </v-flex>

                            <v-flex xs12 md2 class="pa-1">
                                <DatePicker
                                    :default-date="endDate"
                                    v-model="endDate"
                                    label="End Date"
                                />
                            </v-flex>

                            <v-flex xs12 md2 class="pa-1 mb-2">
                                <v-select
                                    label="Select a Program"
                                    :items="programs"
                                    item-text="Name"
                                    item-value="Name"
                                    v-model="program"
                                    clearable
                                    @change="incidentQuery()"
                                ></v-select>
                            </v-flex>


                            <v-flex xs12 md2 class="pa-1 mb-2">
                                <v-select
                                    label="Client Status"
                                    :items="clientStatuses"
                                    v-model="clientStatus"
                                    clearable
                                    @change="incidentQuery()"
                                ></v-select>
                            </v-flex>

                            <v-flex xs12 md2 class="pa-1 mb-2">
                                <v-select
                                    label="Select a Client"
                                    :items="filteredClients"
                                    item-text="Name"
                                    item-value="_id"
                                    v-model="ClientID"
                                    clearable
                                    @change="incidentQuery()"
                                ></v-select>
                            </v-flex>
                            <v-flex xs12 md3 class="mt-5 mb-5 pl-5">
                                <v-btn small @click="incidentQuery()">Search</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-flex>


                <v-flex xs12 class="pa-2">
                    <v-data-table
                        :headers="headers"
                        :items="incidents"
                        sort-by="Name"
                        sort-asc
                        class="elevation-1"
                        :loading="isLoading"
                        loading-text="Loading Incident Reports"
                        :items-per-page="100"
                    >
                        <template v-slot:item.select="{ item }">
                            <v-btn
                                x-small
                                class="white--text"
                                color="#2b3990"
                                @click="viewIncidentReport(item)"
                            >
                                View
                            </v-btn>
                            <v-btn
                                x-small
                                class="white--text"
                                color="#2b3990"
                                @click="downloadIncidentReport(item)"
                            >
                                Download
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-card>

        <div id="print">
            <report-header>
              <h2>Nevada Incident Report</h2>
            </report-header>
            <v-row>
                <v-col cols="12">
                    <v-data-table
                        :headers="headers"
                        :items="incidents"
                        sort-by="Name"
                        sort-asc
                        class="elevation-1"
                        :loading="isLoading"
                        loading-text="Loading Incident Reports"
                        :items-per-page="-1"
                        :page="page"
                        :pageCount="pageCount"
                        :server-items-length="itemCount"
                        :options.sync="options"
                    >
                    </v-data-table>
                </v-col>
            </v-row>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import { STATUS_ARRAY } from '@/enums/UserStatusEnum';
import ReportHeader from '@/components/Report/ReportHeader.vue';
import DatePicker from "@/components/DateTimePickers/DatePicker.vue";

const url = require("../../client_config/config").url;

const NevadaIncidentService = require('../../service/nevada-incident.service');

export default {
    components: {
        DatePicker,
      ReportHeader
    },
    data: () => ({
        headers: [
            {
                text: 'Client',
                align: 'start',
                sortable: true,
                value: 'ClientInfo.Name',
            },
            {text: "Incident Date", value: "IncidentDate"},
            {text: "Program", value: "Program"},
            {text: "Program Type", value: "ProgramType"},
            {text: "Incident Type", value: "Type"},
            {text: "Reporters Signature", value: "ReportersSignature"},
            {text: "Submitted to State", value: "Compliance"},
            {text: "", value: "select", sortable: false},

            // { text: "Actions", value: "actions", sortable: false },
        ],
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        msg: false,
        search: "",
        text: "",
        incidents: [],
        units: [],
        users: [],
        staff: "",
        codes: [],
        tempData: [],
        clientID: '',
        userID: localStorage.getItem("userID"),
        unitID: localStorage.getItem('unitID'),
        requiredField: [
            v => !!v || 'This is required',
        ],
        url: require("../../client_config/config").url,
        states: ["Utah", "Nevada"],
        userState: localStorage.getItem('userState'),
        isLoading: false,
        startDate: "",
        endDate: "",
        ClientID: "",
        program: '',
        clients: [],
        clientStatus: "",
        startMenu: false,
        endMenu: false,
        programs: [],
        clientStatuses: STATUS_ARRAY,
        filteredClients: [],
        page: 1,
        pageCount: 1,
        itemCount: 0,
        options: {},
    }),

    computed: {},

    created() {
        this.getClients();
        this.getPrograms();
        this.incidentQuery();
    },

    watch: {
        clientStatus: function (val) {
            if (val === '' || val == null) this.filteredClients = this.clients;
            else this.filteredClients = this.clients.filter((client) => client.Status === val);
        },
        options: {
            handler() {
                this.incidentQuery();
            },
            deep: true
        },
    },

    methods: {
        initialize() {
            this.clients = [];
        },

        async getClients() {
            let endpoint = `${url}/clients`;

            await axios.get(endpoint)
                .then((res) => {
                    this.clients = res.data.clients;
                    this.filteredClients = this.clients;
                });
        },

        async getPrograms() {
            await axios.get(`${url}/units/state/${this.userState}`)
                .then((res) => {
                    this.programs = res.data.units;
                });
        },

        incidentQuery() {
            this.incidents = [];
            this.isLoading = true;

            this.program = this.program || '';
            this.startDate = this.startDate || '';
            this.endDate = this.endDate || '';
            this.ClientID = this.ClientID || '';

            let {page, itemsPerPage} = this.options;

            page = page || 1;
            itemsPerPage = itemsPerPage || 100;
            this.page = page;

            const params = {
                program: this.program,
                startDate: this.startDate,
                endDate: this.endDate,
                clientId: this.ClientID,
                clientStatus: this.clientStatus,
                page: page,
                limit: itemsPerPage,
                state: this.userState
            }

            console.log({params});

            NevadaIncidentService.get(params)
                .then(response => {
                    this.incidents = response.data.docs || [];


                    this.incidents.sort((a, b) => {
                        return new Date(b.IncidentDate) - new Date(a.IncidentDate);
                    });


                    const {totalPages, totalDocs} = response.data;
                    this.pageCount = totalPages || 0;
                    this.itemCount = totalDocs || 0;
                })

                .catch(error => {
                    console.error('Failed to fetch incidents:', error);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        downloadIncidentReport(item) {
            let id = item._id;
            console.log({itemPdf: item});
            window.open(`${url}/nevadaIncidents/download?id=${id}`);
        },

        viewIncidentReport(item) {
            this.$router.push({
                path: `/nvIncidents/view-incident/${item._id}`,
                query: {clientNav: 'false', 'newIncident': 'false'}
            });
        },

        downloadDocument() {
            window.open(this.newDocument);
        },

        printTable() {

            window.print()
        },

    }
}
</script>
<style>
#print {
    display: none
}

@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }

}


@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }

}

@media print {
    #print {
        display: block;
        border: none;
        width: 1200px;
        padding-right: 300px;
        margin-left: -200px;
    }


    nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
        display: none;
        border: none;

    }

    @page {
        margin: 0;
    }

    body {
        margin: 1.6cm;
    }

    .hideOnPrint {
        display: none;
        border: none;
    }
}
</style>../../enums/UserStatusEnum
